class Link {
  constructor({url, text, type}) {
    /** @type {string} the url of the link */
    this.url = url;
    /** @type {string} the text of the link */
    this.text = text;
    /** @type {string} the type of the link */
    this.type = type;
  }
}

export {Link};
